import { glifoDoMotivo, type MotivoLinha } from '@miolos/core';

/**
 * Desenho das linhas (corações, patinhas, dentinhos, esmaltes...).
 *
 * Usa exatamente os mesmos glifos que a pauta impressa, para a tela e o papel
 * combinarem.
 */
export function GlifoMotivo({
  motivo,
  cor,
  tamanhoMm = 3.4,
  className,
}: {
  motivo: MotivoLinha;
  cor: string;
  tamanhoMm?: number;
  className?: string;
}) {
  const glifo = glifoDoMotivo(motivo);
  if (!glifo) return null;

  const traco = 2.1 - Math.min(1.1, tamanhoMm / 4);

  return (
    <svg
      viewBox="0 0 24 24"
      width={`${tamanhoMm}mm`}
      height={`${tamanhoMm}mm`}
      fill="none"
      stroke={cor}
      strokeWidth={traco}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden
      style={{ flex: '0 0 auto' }}
      dangerouslySetInnerHTML={{ __html: glifo.replace(/__COR__/g, cor) }}
    />
  );
}
